<template>
    <div>
        <button @click.prevent="clickBack" class="btn-back"></button>
    </div>
</template>

<script>
export default {
    name:"BackButton",
    props: {
        routeName: {
            type: String,
            default: null
        }
    },
    methods: {
        clickBack() {
            if (this.routeName === null) {
                this.$router.go(-1);
            } else {
                this.$router.push({name : this.routeName});
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .btn-back {
        @extend .reset-btn;
        background-image : url('/img/btn-back.svg');
        width : 4rem;
        height : 4rem;
        position: fixed;
        top: 5.5rem;
        left: 1.8rem;
        z-index: 5;
        transition : opacity 250ms;

        @include slideIntroAnimation(basicSlideIntro, 350ms, 0ms);

        &:active {
           opacity: .75;
        }

    }
</style>